import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthService } from './auth.service';

export const guestGuard: CanActivateFn = (): boolean | UrlTree => {
  const auth = inject(AuthService);
  const router = inject(Router);

  // si session valide → on renvoie vers l’app
  if (auth.hasValidSession()) {
    return router.parseUrl('/');
  }
  return true;
};
